import React, { Component } from "react";

class PriceAlertButtonA extends Component {
	render() {
		return (
			<div className="new-card new-card--price-alert" {...this.props} data-action="price-alert-open">
				<header className="new-card__header">
					<h2 className="new-card__title new-card__title-regular">Alerta de preço</h2>					
					<div className="alert-icon">
						<i className="icon-bell" />
					</div>
				</header>
			</div>
		);
	}
}

export default PriceAlertButtonA;
